import React, { useEffect, useState } from "react";
import "./SocialShare.scss";
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";

const SocialShare = ({ title, url }) => {
  const [stickyshare, setStickyShare] = useState("");
  useEffect(() => {
    window.addEventListener("scroll", () => {
      const scrollHeight = window.scrollY; // Get window scroll height
      if (scrollHeight > 647) {
        setStickyShare("sticky"); // Add .scrolled class to header
      } else if (scrollHeight < 647) {
        setStickyShare(""); // Remove .scrolled class from header
      }
    });
  });
  return (
    <div className={`SocialShare ${stickyshare}`}>
      <EmailShareButton url={url} title={title}>
        <EmailIcon size={40} />
      </EmailShareButton>
      <LinkedinShareButton url={url} title={title}>
        <LinkedinIcon size={40} />
      </LinkedinShareButton>
      <FacebookShareButton url={url} title={title}>
        <FacebookIcon size={40} />
      </FacebookShareButton>
      <TwitterShareButton url={url} title={title}>
        <TwitterIcon size={40} />
      </TwitterShareButton>
    </div>
  );
};
export default SocialShare;
